import styles from './TransactionStatus.module.scss';
import { withStyles, Icon, MaterialSymbol } from 'vopay';

type TransactionStatusProps = {
  status:
    | 'requested'
    | 'pending'
    | 'completed'
    | 'failed'
    | 'in progress'
    | 'sent'
    | 'upcoming'
    | 'successful'
    | 'complete'
    | 'settled'
    | 'failed'
    | 'cancelled'
    | 'cancellation requested'
    | 'pending Approval'
    | 'waiting'
    | 'active'
    | 'not active'
    | 'neutral'
    | 'positive'
    | 'negative'
    | 'info'
    | 'blocked'
    | 'rejected'
    | 'approved'
    | string;
  label: string;
};

const classes = withStyles(styles);

const TransactionStatus: React.FC<TransactionStatusProps> = ({ status, label }) => {
  const getStatusIcon = () => {
    // Define the icons for each status
    const statusIcons: { [key: string]: React.ReactNode } = {
      requested: <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      neutral: <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      info: <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      pending: <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      failed: <MaterialSymbol icon="cancel" size="18px" color="#e8160b" />,
      'in progress': <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      sent: <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      upcoming: <MaterialSymbol icon="calendar_today" size="18px" />,
      successful: <MaterialSymbol icon="check_circle" size="18px" color="#008107" />,
      complete: <MaterialSymbol icon="check_circle" size="18px" color="#008107" />,
      settled: <MaterialSymbol icon="check_circle" size="18px" color="#008107" />,
      active: <MaterialSymbol icon="check_circle" size="18px" color="#008107" />,
      positive: <MaterialSymbol icon="check_circle" size="18px" color="#008107" />,
      negative: <MaterialSymbol icon="cancel" size="18px" color="#e8160b" />,
      cancelled: <MaterialSymbol icon="cancel" size="18px" color="#e8160b" />,
      blocked: <MaterialSymbol icon="block" size="18px" color="#e8160b" />,
      'cancellation requested': <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      'pending Approval': (
        <div>
          <Icon icon="transactionPending" height="18px" width="18px" color="none" />
        </div>
      ),
      waiting: <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      'not active': <Icon icon="transactionPending" height="18px" width="18px" color="none" />,
      rejected: <MaterialSymbol icon="cancel" size="18px" color="#e8160b" />,
      approved: <MaterialSymbol icon="check_circle" size="18px" color="#008107" />,
    };

    // Return the icon based on the status
    return statusIcons[status] || <Icon icon="transactionPending" height="18px" width="18px" color="none" />;
  };

  const getStatusColor = () => {
    // Define the colors for each status
    const statusColors: { [key: string]: string } = {
      requested: 'gray',
      neutral: 'gray',
      info: 'gray',
      pending: 'gray',
      failed: 'red',
      'in progress': 'gray',
      sent: 'gray',
      upcoming: 'blue',
      successful: 'green',
      complete: 'green',
      settled: 'green',
      active: 'green',
      positive: 'green',
      negative: 'red',
      'not active': 'gray',
      cancelled: 'red',
      'cancellation requested': 'gray',
      'pending Approval': 'gray',
      waiting: 'gray',
      blocked: 'grey',
      rejected: 'red',
      approved: 'green',
    };

    // Return the color based on the status
    return statusColors[status] || 'gray';
  };

  return (
    <div className={classes('transactionStatus', getStatusColor())}>
      {getStatusIcon()}
      <div className={classes('statusLabel')}>{label}</div>
    </div>
  );
};

export default TransactionStatus;
